import { Component, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/Services/permissions.service';
import { BooleanCheckOrCrossViewColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-citation-exemption-lists',
    templateUrl: './citation-exemption-lists.component.html',
    styleUrls: ['./citation-exemption-lists.component.scss'],
    standalone: false
})
export class CitationExemptionListsComponent implements OnInit {

  public CanWrite: boolean = false;

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn('Id', 'Id'),
    new Datalistviewcolumn('Name', 'Name'),
    new Datalistviewcolumn('Description', 'Description'),
    new BooleanCheckOrCrossViewColumn('Active', 'IsActive'),
    new Datalistviewcolumn('Expires', 'ExpiresOnLocalFriendlyString'),
    new Datalistviewcolumn('Entries', 'EntryCount'),
  ];

  constructor(private permissionsService: PermissionsService) { }

  async ngOnInit(): Promise<void> {
    this.CanWrite = await this.permissionsService.CheckAdminPermission('EnforcementFeature', 500);
  }
}
